import { AriaRole } from 'react';
import { flushSync } from 'react-dom';
import { LinkProps, useNavigate } from 'react-router-dom';

interface Props extends LinkProps {
    role?: AriaRole;
    tabIndex?: number;
}

const AnimatedLink = ({ to, className, children, role, title, tabIndex }: Props) => {
    const navigate = useNavigate();

    return (
        <a
            className={className}
            href={to.toString()}
            onClick={(ev) => {
                ev.preventDefault();
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                if (document.startViewTransition) {
                    document.startViewTransition(() => {
                        flushSync(() => {
                            navigate(to);
                        });
                    });
                } else {
                    flushSync(() => {
                        navigate(to);
                    });
                }
            }}
            role={role ? role : 'link'}
            aria-disabled={className?.includes('is-disabled')}
            title={title}
            tabIndex={tabIndex}
        >
            {children}
        </a>
    );
};

export default AnimatedLink;
